(() => {
  const selector = 'shopify-forms-embed#app-embed-container-1176892';
  const styleId = 'hokema-popup-mobile';
  const css = `
    @media (max-width: 767px) {
      :host {
        --spacing-size-y: 16px;
        --spacing-size-x: 18px;
        --min-form-width: 0px;
      }
      [data-layout="overlay"] [role="dialog"][data-sizing="form-wrapper"] {
        width: calc(100vw - 24px) !important;
        max-width: 420px !important;
        min-width: 0 !important;
        max-height: calc(100vh - 24px) !important;
        max-height: calc(100dvh - 24px) !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
        grid-template-rows: 170px min-content !important;
      }
      [data-layout="overlay"] [class*="_gridItem_"]:first-child {
        height: 170px !important;
        min-height: 0 !important;
        background-size: contain !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
      }
      [data-layout="overlay"] [class*="_formHeader_"] {
        margin-bottom: 14px !important;
        gap: 8px !important;
      }
      [data-layout="overlay"] [class*="_formFieldset_"] {
        gap: 12px !important;
        margin-top: 12px !important;
      }
      [data-layout="overlay"] [class*="_formDisclaimer_"] {
        margin-top: 12px !important;
      }
      [data-layout="overlay"] [class*="_formContainerCloseButtonPosition_"] {
        top: 8px !important;
        right: 8px !important;
      }
    }
  `;
  const roots = new WeakSet();
  const install = () => {
    const host = document.querySelector(selector);
    const root = host && host.shadowRoot;
    if (!root) return;
    const ensure = () => {
      if (root.getElementById(styleId)) return;
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.append(style);
    };
    ensure();
    if (!roots.has(root)) {
      roots.add(root);
      new MutationObserver(ensure).observe(root, {childList: true, subtree: true});
    }
  };
  new MutationObserver(install).observe(document.documentElement, {childList: true, subtree: true});
  customElements.whenDefined('shopify-forms-embed').then(install);
  install();
  let attempts = 0;
  const timer = setInterval(() => {
    install();
    if (++attempts >= 60 || document.querySelector(selector)?.shadowRoot) clearInterval(timer);
  }, 1000);
})();
